import { instanceOf } from 'prop-types'
import cn from 'classnames'

import PostText from '../../theme-components/post-text.js'
import Icon from '../../../icon/index.js'
import Post from '../../../../../models/Post.js'
import Settings from '../../../../../models/settings.js'

export default function SocialIconAndText({ post, settings }) {
  return (
    <div
      className={cn('bzfy-c-tilegrid-post__text', {
        'bzfy-c-tilegrid-post__text--with-social': settings.showPlatformIcon,
      })}
      style={{ color: settings.postColor }}
    >
      {settings.showPostText && (
        <PostText hashtagColor={settings.hashtagColor} maxLength={140} postText={post.text} />
      )}
      {settings.showPlatformIcon && (
        <div className="bzfy-c-tilegrid-post__text-cta">
          <div className="bzfy-c-tilegrid-post__profile-content-block">
            <Icon
              className="bzfy-c-tilegrid-post__social-icon"
              color={settings.postColor}
              icon={`social-${post.sourceName}`}
            />
          </div>
        </div>
      )}
    </div>
  )
}

SocialIconAndText.propTypes = {
  post: instanceOf(Post).isRequired,
  settings: instanceOf(Settings).isRequired,
}
